module.exports = __webpack_public_path__ + "img/industries_news_light_1.154f30eb.png";